// Bootstrap 5 CSS — primero, como base
import 'bootstrap/dist/css/bootstrap.min.css';

// Bootstrap 5 JS (necesario para dropdowns, modales, etc.)
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Estilos originales del sistema ASP
import './main.css';
import './wheel.css';

// Clases propias de la app (.button, .color1, .campo_fino)
import './app.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
